import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';

import Form from '../../../../../../components/Form/Form';
import Spinner from '../../../../../../components/Spinner';

import './ChangePassword.scss';

const UpdateUserMutation = gql`
mutation (
  $password: String
) {
  updateUser(input: {
    password: $password
  }) {
    id
    redirect_url
  }
}
`;

const mapStateToProps = (state) => {
  console.log(state.auth);
  return ({
    authedUser: state.auth || null,
  });
};

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentValues: {},
      error: null,
      loading: false,
      complete: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmission = this.handleSubmission.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
  }

  handleChange(event) {
    this.setState({
      currentValues: event.target.value,
      error: null,
    });
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 13: // Enter
        event.preventDefault();
        this.handleSubmission();
        break;
    }
  }

  handleSubmission() {
    const FormData = this.state.currentValues;
    const validateInput = (form, input) => !(Object.prototype.hasOwnProperty.call(form, input) && form[input] !== '');

    if (validateInput(FormData, 'password')) {
      this.setState({
        error: 'Please enter a password',
      });
      return;
    }

    if (validateInput(FormData, 'password_confirm')) {
      this.setState({
        error: 'Please repeat the password',
      });
      return;
    }

    if (FormData['password'] !== FormData['password_confirm']) {
      this.setState({
        error: 'Passwords must match',
      });
      return;
    }

    this.setState({
      loading: true,
    });

    this.props.UpdateUser({
      variables: {
        password: FormData['password'],
      }
    }).then(Data => {
      console.log(JSON.stringify(Data.data, null, 2));
      this.setState({
        loading: false,
        complete: true,
      });

      window.setTimeout((UserObject => () => {
        console.log(UserObject);

        if (Data.data.updateUser.redirect_url !== '' && Data.data.updateUser.redirect_url !== null) {
          window.location.href = Data.data.updateUser.redirect_url;
        } else if ((UserObject.User.roles || []).some(Role => Role.name === 'Advisor')) {
          window.location.href = window.location.origin + '/advisor/profile';
        } else {
          window.location.href = __LaravelDomain;
        }
      })(this.props.authedUser), 3000);
    }).catch(err => {
      this.setState({
        error: err,
      });
    });
  }

  render() {
    if (this.state.complete === false) {
      return (
        <div className='ChangePassword__Wrapper'>
          <Form>
            <h2 className='FormSegment__title'>Change your password</h2>
            {(this.state.error !== null) ? <p className='errorText'>{this.state.error}</p> : null}
            <Form onChange={this.handleChange}>
              <div className='row'>
                <div className='col-md'>
                  <input type='password' placeholder='Password' onKeyDown={this.handleOnKey} className='Form__Input' name='password' />
                </div>
              </div>
              <div className='row'>
                <div className='col-md'>
                  <input type='password' placeholder='Confirm Password' onKeyDown={this.handleOnKey} className='Form__Input' name='password_confirm' />
                </div>
              </div>
            </Form>
            <span onClick={this.handleSubmission} className='Button__Submit'>
              {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Submit'}
            </span>
          </Form>
        </div>
      );
    }

    return (
      <div>
        <p style={{ textAlign: 'center', margin: '20px' }}>Password updated. Redirecting</p>
      </div>
    );
  }
}

export default compose(
  graphql(UpdateUserMutation, {
    name: 'UpdateUser'
  }),
)(connect(mapStateToProps)(ChangePassword));



// WEBPACK FOOTER //
// ./src/routes/user/routes/ChangePassword/components/ChangePassword/index.js